const jobCrawlerSources = [
    {value: 'usps', label: 'USPS'},
    {value: 'dhl', label: 'DHL'},
    {value: 'canada-post', label: 'Canada Post'},
    {value: 'asendia', label: 'Asendia'},
    {value: 'asendia-usa', label: 'Asendia USA'},
    {value: 'yunexpress', label: 'Yunexpress'},
]

export default jobCrawlerSources
